import { createContext, ReactNode, useContext, useState } from "react";

export type ErrorInfo = { title?: string; message: string };

export const ErrorAlertContext = createContext({
  error: undefined as undefined | ErrorInfo,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setError: (_error: undefined | ErrorInfo) => {},
});

export const ErrorAlertProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<ErrorInfo | undefined>(undefined);

  return (
    <ErrorAlertContext.Provider value={{ error, setError }}>
      {children}
    </ErrorAlertContext.Provider>
  );
};

export default function useErrorAlert() {
  return useContext(ErrorAlertContext);
}
